import { useContext } from 'react';

import { MediaContext } from './MediaContextProvider';
import { MediaType } from './types';

export function useMediaType(mediaType: MediaType): boolean {
  const context = useContext(MediaContext);
  if (!context) {
    throw new Error('Must be used inside a MediaContextProvider');
  }
  return context.mediaTypeMatches[mediaType];
}
